import { ca } from '@cian/analytics';

interface ITrackOpenChatParams {
  label: string;
  placeType: string;
  sellerType?: 'builders' | 'agents';
}

export function trackOpenChat({ label, placeType, sellerType }: ITrackOpenChatParams) {
  ca('eventSite', {
    action: 'open',
    category: 'Message_popup',
    label,
    name: 'oldevent',
    useLastProducts: true,
    page: {
      extra: {
        type: placeType,
        seller_type: sellerType,
      },
    },
  });
}
